import { SEARCH_PARAMETERS } from "../searchResults/constants";
import { LineOfBusinessConfig } from "../claimsSearchBar/legacySearchBarSupport";
import { ROUTES } from "src/app/constants";

export const CLAIMS_LIMIT = 100;

// Cargo-specific search configuration
export const CARGO_LINE_OF_BUSINESS_CONFIG: LineOfBusinessConfig = {
  searchByLabels: {
    [SEARCH_PARAMETERS.VRID_LOAD_ID]: {
      buttonText: "Search",
      buttonTextSmall: "Search",
      placeholder: "Search for cargo claims using the VRID/Load ID",
      placeholderSmall: "Search by VRID/Load ID",
    },
  },
  availableSearchParameters: [SEARCH_PARAMETERS.VRID_LOAD_ID],
  routePath: ROUTES.CARGO_CLAIMS_HISTORY,
  metricsPrefix: "cargo",
};
